import UserTag from "./components/UserTag";
import UserDetails from "./components/UserDetails";

const Plugin = {
  install(app) {
    app.component("user-tag", UserTag);
    app.component("user-details", UserDetails);
  },
};

export default Plugin;
